// extracted by mini-css-extract-plugin
module.exports = {"brandLine":"TextTwoColumns_brandLine__MnHrL","marginBottom":"TextTwoColumns_marginBottom__ZROUb"};